module.exports = __webpack_public_path__ + "media/nod.a5b88f32.mp3";